import React from 'react'
import IndicatorIcon from '../../../../../shared/components/Icons/IndicatorIcon'
import { FilterIcon } from '../../../../icons'
import { useActiveFilters } from '../../../filters'
import SedaPanelButton from './SedaPanelButton'
import { getActiveFilterCount } from '../../../filters'

export default function SedaFilterPanelButton(props) {
  // do not include sort in the filter count, as it doesn't filter any data
  const activeFilters = useActiveFilters()
  const filterCount = getActiveFilterCount(activeFilters)

  return (
    <SedaPanelButton
      panelId="filter"
      secondary={filterCount + ' active filters'}
      icon={
        <IndicatorIcon indicator={filterCount ? filterCount : 0}>
          <FilterIcon />
        </IndicatorIcon>
      }
      {...props}
    />
  )
}
